import Type from 'components/Type'

const TextButton = ({ children, ...props }) => (
  <Type 
    color="text.primaryHue" 
    variant="button" 
    hover 
    selectable 
    {...props}
  >
    {children}
  </Type>
)

export default TextButton
